<template>
  <sweet-modal ref="modal" width="40%" :title="$t('ct-transfer')" hide-close-button blocking>
    <form v-if="site && !$isBundle()">
      <div class="form-group">
        <label for="email-transfer">{{ $t('ct-email')}}</label>
        <input
          type="email"
          class="form-control"
          :class="{ 'is-invalid': errors.has('email') }"
          name="emailTransfer"
          id="email-transfer"
          placeholder
          v-model="email"
          @keydown="errors.clear('email')"
          @change="validateEmail"
        />
        <span v-if="errors.has('email')" class="invalid-feedback" v-text="$t(errors.get('email'))"></span>
      </div>

      <!-- <alert-box-component class="py-3 text-center">
        <p slot="content" class="text-center w-100 m-0" v-text="$t('ct-transfer-info-blog-turbo')"/>
      </alert-box-component> -->

      <alert-box-component type="error" class="py-3 mt-2 text-center" :with_icon="true" v-if="site.is_mirror">
        <p slot="content" class="text-center w-100 m-0" v-text="$t('ct-transfer-mirror')"/>
      </alert-box-component>

      <div class="form-group mt-3">
        <label>{{ $t('ct-transfer-choose-option')}}</label>
        <div class="d-flex flex-row box-choose-type-transfer">
          <div v-if="!withBlog">
            <div class="box-type-transfer bg-white only-transfer" @click="$refs.typeOnly.click()" :class="{ 'selected': type === 'only-transfer' }">
              <i class="input-radio-icon m-2"></i>
              <img src="/static/images/transfer-img.svg"/>
              <input
                type="radio"
                id="typeOnly"
                ref="typeOnly"
                name="type"
                value="only-transfer"
                v-model="type"
                @change="errors.clear('type')"
                class="d-none"
              />
            </div>
            <label for="typeOnly">{{ $t('ct-transfer-only')}}</label>
          </div>

          <div v-if="!site.is_mirror">
            <div class="box-type-transfer bg-white duplicate-transfer"  @click="$refs.typeDuplicate.click()" :class="{ 'selected': type === 'duplicate-transfer' }">
              <i class="input-radio-icon m-2"></i>
              <img src="/static/images/duplicar-icon.svg"/>
              <input
                type="radio"
                id="typeDuplicate"
                ref="typeDuplicate"
                name="type"
                value="duplicate-transfer"
                v-model="type"
                @change="errors.clear('type')"
                class="d-none"
              />
            </div>
            <label for="typeDuplicate">{{ $t('ct-transfer-duplicate')}}</label>
          </div>
        </div>
        <span
          v-if="errors.has('type')"
          class="invalid-feedback"
          v-text="errors.get('type')"
          :class="{ 'd-block': errors.has('type') }"
        ></span>
      </div>
    </form>
    <!-- Premium templates cannot be transfered -->
    <div v-else>
      <p>{{ $t('ct-plan-limited-transfer') }}</p>
    </div>
    <button
      slot="button"
      class="btn btn-outline-light"
      @click="closeModalTransfer()"
    >{{ $t('ct-cancel')}}</button>
    <button v-if="!$isBundle()" slot="button" class="btn btn-success" @click="confirmSave"><i class="svg-icon svgi-save"></i>{{ $t('ct-save')}}</button>
  </sweet-modal>
</template>

<script>
import { SweetModal } from 'sweet-modal-vue';
import Errors from '../../../../js/base/Errors';
import {
  transferWebsite,
  transferDuplicateWebsite
} from '../../../../js/services/editor/website';
import AlertBoxComponent from "../../../commons/AlertBoxComponent";

export default {
  name: 'SiteTransferComponent',
  components: { SweetModal, AlertBoxComponent },
  props: ['show', 'site'],

  data() {
    return {
      errors: new Errors(),
      email: String(),
      type: String()
    };
  },

  watch: {
    show: function(value) {
      if (value) this.$refs.modal.open();
      else this.$refs.modal.close();

      this.email = String();
      this.type = String();
      this.errors.clear();
    }
  },

  computed: {
    withBlog(){
      if (this.site.type === 'static_import') {
        return false;
      }
      return this.site.layouts[0].pages.filter(page => page.is_blog || page.is_turbo).length
    }
  },

  methods: {
    closeModalTransfer() {
      this.$store.dispatch('dashboard/transferWebsite', { show: false });
    },

    validateEmail() {
      const regex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
      if (!this.email || !regex.test(this.email.toLowerCase())) {
        this.errors.add('email', ('validation-regex'));
      }
    },
    validate() {
      if (!this.email && !(this.email.length > 0)) { this.errors.add('email', ('validation-required')) }

      if (!this.type && !(this.type.length > 0)) { this.errors.add('type', 'validation-required') }

      if (
        this.type &&
        this.type.length > 0 &&
        !(this.type === 'only-transfer' || this.type === 'duplicate-transfer')
      ) { this.errors.add('type', 'validation-invalid-type') }

      return !this.errors.any();
    },

    confirmSave() {
      if (this.validate()) {
        this.$loading.show();
        if (this.type === 'only-transfer') this.transferWebsite();
        else if (this.type === 'duplicate-transfer') { this.transferDuplicateWebsite() }
      }
    },

    responseSuccess(response) {
      let status = response.data.success;

      if (status) {
        this.closeModalTransfer();
        this.$emit('updateWebsites');

        this.$snotify.success(this.$t('ct-success-true'), {
          position: 'centerTop'
        });

        this.email = String();
        this.type = String();
        this.errors.clear();
      } else {
        if (response.data.error && response.data.error.email) {
          if (response.data.error.email[0] === 'The selected email is invalid.') {
            response.data.error.email[0] = this.$t(
              'ct-transfer-invalid-user-email'
            );
          }

          this.errors.record(response.data.error);
        } else {
          this.$snotify.error(this.$t('ct-success-false'), {
            position: 'centerTop'
          });
        }
      }
    },

    transferWebsite() {
      transferWebsite(this.site, { email: this.email })
        .then(response => {
          this.responseSuccess(response);
        })
        .catch(error => {
          if (error.response.status === 401) {
              this.$snotify.error(this.$t('ct-plan-limited-transfer'));
            } else {
              this.$snotify.error(this.$t('ct-success-false'), {
                position: 'centerTop'
              });
            }

        })
        .finally(() => this.$loading.hide());
    },

    transferDuplicateWebsite() {
      transferDuplicateWebsite(this.site, { email: this.email })
        .then(response => {
          this.responseSuccess(response);
        })
        .catch(error => {
            if (error.response.status === 401) {
              this.$snotify.error(this.$t('ct-plan-limited-transfer'));
            } else {
              this.$snotify.error(this.$t('ct-success-false'), {
                position: 'centerTop'
              });
            }
        })
        .finally(() => this.$loading.hide());
    },
  },
};
</script>

<style lang="scss" scoped>
label {
  font: normal normal medium 16px/19px Lato;
  color: #6E6E6E;
}

.box-choose-type-transfer {

  display: flex;
  align-items: center;
  justify-content: center;

  text-align: center;
  margin-top: 10px;

  label {
    font: normal normal normal 14px/35px Muli;
    color: #333333;

    margin: 5px 0;
  }

  .box-type-transfer {
    width: 160px;
    height: 160px;
    border: 2px dotted #B0BFCE;
    border-radius: 10px;

    position: relative;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    margin: 0 15px;

    .input-radio-icon {
      top: 0;
      right: 0;
    }

    &.selected {
      border: 2px dotted #0080FC;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/layout/site/SiteTransfer.vue